export const VIDEO_FEEDBACK_POLL_DURATION = 10 * 1000; // 10 sec
export const VIDEO_FEEDBACK_POLL_END_DURATION = 60 * 3 * 1000; // 180 sec
export const VIDEO_FEEDBACK_MESSAGE_DURATION = 20 * 1000; // 20 sec

export enum VideoFeedbackStatus {
  PENDING_GENERATION = 'PENDING_GENERATION',
  GENERATION_ERROR = 'GENERATION_ERROR',
  RENDERING = 'RENDERING',
  AVAILABLE = 'AVAILABLE',
  GENERATION_DISABLED = 'GENERATION_DISABLED',
}
